<template>
  <div class="cards-container">
    <CardPresentation
      :cardType="cardType"
      :hasCards="hasCards"
      :currentCardNum="currentCardNum"
      :currentCard="currentCard"
      :totalCardNum="totalCardNum"
    />
    <CardController
      @goPrev="goPrevCard"
      @goNext="goNextCard"
      @newCard="onNewCard"
      @delCard="onDelCard"
      @editCard="onEditCard"
      :hasPrev="hasPrev"
      :hasNext="hasNext"
      :currentCollId="currentCollId"
      :currentCard="currentCard"
    />
  </div>
</template>

<script>

import CardPresentation from './CardPresentation.vue'
import CardController from './CardController.vue'
import {store} from "../store.js"


export default {
  name: 'CardsContainer',
  props: ['cards', 'collection', 'currentCollId'],
  data: function(){
    return {
      currentCardNum_: 0,
    }
  },
  computed: {
    currentCard: function(){
      return this.cards[this.currentCardNum_]
    },
    cardType: function(){
      return this.currentCard? this.currentCard.cardType: null
    },
    hasCards: function(){
      return !!this.currentCard
    },
    currentCardNum: function(){
      return this.currentCardNum_ + 1
    },
    totalCardNum: function(){
      return this.cards.length
    },
    hasNext: function(){
      return this.currentCardNum_ < this.cards.length - 1
    },
    hasPrev: function() {
      return this.currentCardNum_ > 0
    }
  },

  components: {
    CardPresentation,
    CardController
  },
  beforeUpdate(){
  },
  updated(){
    if (store.lastSeenCardNum != null){
      if (store.lastSeenCardNum >= this.cards.length ) {
        this.currentCardNum_ = this.cards.length -1
      } else {
        this.currentCardNum_ = store.lastSeenCardNum
      }
      store.lastSeenCardNum = null
    }

  },
  methods: {
    goPrevCard: function(){
      this.currentCardNum_ -= 1
    },
    goNextCard: function(){
      this.currentCardNum_ += 1
    },
    onNewCard() {
      store.lastSeenCardNum = this.currentCardNum_
      this.$emit("newCard")
    },
    onDelCard(){
      store.lastSeenCardNum = this.currentCardNum_
      this.$emit("delCard", this.currentCard, this.currentCardNum_)
    },
    onEditCard(){
      this.$emit("editCard", this.currentCard)
    }
  },
  watch: {
    cards: function(){
      this.currentCardNum_ = 0
    }
  }
}
</script>

<style scoped>
.cards-container{

}
</style>
